import React from 'react';
import RentersInsuranceLayout from '../../layouts/RentersInsuranceLayout';
import ConsumerReports from './ConsumerReports';

export const ConsumerReportsContainer = () => {
  return (
    <RentersInsuranceLayout withFooter={false}>
      <ConsumerReports />
    </RentersInsuranceLayout>
  );
};
export default ConsumerReportsContainer;
